import { useState } from "react";

import { ErroDeApi, login } from "../api";

/**
 * Login por e-mail/senha contra svc-identity (`POST /api/auth/login`).
 *
 * O token não é devolvido daqui: `login()` já o guarda em memória (api.ts).
 * Este componente só sabe que deu certo — quem decide o que fazer com uma
 * sessão autenticada é o `App`.
 */
export function LoginPage({ onEntrar }: { onEntrar: () => void }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function entrar(e: React.FormEvent) {
    e.preventDefault();
    setEnviando(true);
    setErro(null);
    try {
      await login(email, senha);
      onEntrar();
    } catch (ex) {
      setErro(
        ex instanceof ErroDeApi && ex.status === 401
          ? "E-mail ou senha inválidos."
          : "Não foi possível entrar. Tente novamente.",
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login">
      <form className="login-cartao" onSubmit={entrar}>
        <div className="login-marca">
          <span className="login-selo" aria-hidden="true">N</span>
          <h1>Nexus Supply Chain IA</h1>
          <p>Entre com sua conta para continuar.</p>
        </div>

        <label>
          <span>E-mail</span>
          <input
            type="email" autoComplete="username" required autoFocus
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          <span>Senha</span>
          <input
            type="password" autoComplete="current-password" required
            value={senha} onChange={(e) => setSenha(e.target.value)}
          />
        </label>

        {erro && (
          <div className="aviso" role="alert">
            <span>{erro}</span>
          </div>
        )}

        <button type="submit" disabled={enviando}>
          {enviando ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
